import { TooltipedIconComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { USER_LOCATION_ASSIGNMENT_I18N_PREFIX } from 'modules/settings/pods/settings-user-location-assignment/settings-user-location-assignment.constants';
import { TenantUsersRowActionsStyled } from './tenant-users-row-actions.style';

interface TenantUsersRowActionsComponentProps {
    userId: string;
    userName: string;
    onEditLocations: (userId: string) => void;
}

export const TenantUsersRowActionsComponent: React.FC<TenantUsersRowActionsComponentProps> = ({
    userId,
    userName,
    onEditLocations,
}) => {
    const { t } = useTranslation();

    // The row itself is clickable, so the icon must not fire the row handler as well.
    const handleClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        onEditLocations(userId);
    };

    return (
        <TenantUsersRowActionsStyled>
            <TooltipedIconComponent
                dataTestId={`options-menu-${userId}-locations`}
                tooltipText={t(`${USER_LOCATION_ASSIGNMENT_I18N_PREFIX}.row-actions.locations`)}
                ariaLabel={t(`${USER_LOCATION_ASSIGNMENT_I18N_PREFIX}.row-actions.locations-aria`, {
                    name: userName,
                })}
                onClick={handleClick}
                icon="locator"
                family="outlined"
            />
        </TenantUsersRowActionsStyled>
    );
};
